module.exports = __webpack_public_path__ + "static/img/user-outlined.1e1c1ab4.svg";